module.exports = __webpack_public_path__ + "r-v3/img/translation_VI.a7c07f55.png";